import {FC, useState} from "react";
import {FaqAccordionType, i18translateType} from "../../@types/types-body";
import {FaqAccordionLink} from "@components/faq/faq-accordion-link";
import {useTranslation} from "next-i18next";
import {motion} from 'framer-motion';

export const FaqAccordion: FC<FaqAccordionType> = ({
                                                       id, namespace, object,
                                                   }) => {
    const {t}: i18translateType = useTranslation(namespace);
    const [isActive, setIsActive] = useState("accordion-collapse-body-0");

    function setActive(value: string) {
        if (isActive === value) {
            setIsActive("");
        } else {
            setIsActive(value);
        }
    }

    return (<div
        id={`accordion-collapse-faq-${id}`}
        key={`accordion-collapse-faq-${id}`}
        data-accordion="collapse"
        className="flex flex-row w-full"
    >
        <div className="flex flex-col w-full">
            {Object.keys(t(`${object}`, {returnObjects: true})).map((objectValue, index) => (<motion.div
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                exit={{opacity: 0}}
                transition={{
                    duration: 2, ease: "easeInOut", times: [0,1]
                }}
                key={`${object}-${objectValue}-${index}`}
                id={`${object}-${objectValue}-${index}`}
            >
                <FaqAccordionLink
                    key={`faq-${object}-${objectValue}-${index}`}
                    id={index}
                    namespace={namespace}
                    isActive={isActive}
                    setActive={setActive}
                    title={`${object}.${objectValue}.title`}
                    text={`${object}.${objectValue}.text`}
                />
            </motion.div>))}
        </div>
    </div>);
};
